import { render, staticRenderFns } from "./OfferComponentGroupsModal.vue?vue&type=template&id=4de3baf7&scoped=true"
import script from "./OfferComponentGroupsModal.vue?vue&type=script&lang=js"
export * from "./OfferComponentGroupsModal.vue?vue&type=script&lang=js"
import style0 from "./OfferComponentGroupsModal.vue?vue&type=style&index=0&id=4de3baf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de3baf7",
  null
  
)

export default component.exports